import { defineStore } from 'pinia';
import SalesAPI from 'dashboard/api/sales';

export const useSalesStore = defineStore('sales', {
  state: () => ({
    dashboard: null,
    uiFlags: {
      fetchingDashboard: false,
      creatingSale: false,
      updatingSale: false,
      cancellingSale: false,
    },
  }),

  getters: {
    getDashboard: state => state.dashboard,
    isManager: state => state.dashboard?.role === 'manager',
  },

  actions: {
    async fetchDashboard(params = {}) {
      this.uiFlags.fetchingDashboard = true;
      try {
        const { data } = await SalesAPI.dashboard(params);
        this.dashboard = data;
      } finally {
        this.uiFlags.fetchingDashboard = false;
      }
    },

    async createSaleForConversation(conversationDisplayId, payload) {
      this.uiFlags.creatingSale = true;
      try {
        const { data } = await SalesAPI.createForConversation(
          conversationDisplayId,
          { sale: payload }
        );
        return data;
      } finally {
        this.uiFlags.creatingSale = false;
      }
    },

    async updateSaleForConversation(conversationDisplayId, saleId, payload) {
      this.uiFlags.updatingSale = true;
      try {
        const { data } = await SalesAPI.updateForConversation(
          conversationDisplayId,
          saleId,
          { sale: payload }
        );
        return data;
      } finally {
        this.uiFlags.updatingSale = false;
      }
    },

    async cancelSaleForConversation(conversationDisplayId, saleId, cancellationReason) {
      this.uiFlags.cancellingSale = true;
      try {
        const { data } = await SalesAPI.cancelForConversation(
          conversationDisplayId,
          saleId,
          { cancellation_reason: cancellationReason }
        );
        return data;
      } finally {
        this.uiFlags.cancellingSale = false;
      }
    },
  },
});
